import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { langHelper } from './shared/helpers-and-utilities/language-helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'spruha';
  // public isSpinner = true;

  // ngOnInit(): void {
  //   setTimeout(() => {
  //     this.isSpinner = false;
  //   },1000)
  // }
  constructor(translate: TranslateService,langHelper :langHelper) {
    const lng = langHelper.currentLang;
    translate.setDefaultLang(lng);
    translate.use(lng);
    const supportedLangs = ["en", "ar"];
    supportedLangs.forEach((language) => {
      translate.reloadLang(language);
    });

    // const browserLang: string = translate.getBrowserLang()!;
    // translate.use(browserLang.match(/en|ar/) ? browserLang : 'ar');
    // console.log("browserLang",browserLang)
    console.log(translate.currentLang)
  }
}
